import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1651f740"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-relative tw-flex tw-items-center" }
const _hoisted_2 = {
  key: 0,
  id: "menu-list",
  "data-testid": "studio-account-menu",
  class: "tw-absolute tw-right-0 tw-top-9 tw-z-50 tw-w-48 tw-overflow-hidden tw-rounded-lg tw-border tw-bg-white tw-text-xs tw-shadow-lg dark:tw-bg-black"
}
const _hoisted_3 = ["id", "data-testid", "onClick"]
const _hoisted_4 = { class: "tw-font-medium" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-px-3 tw-py-3 tw-text-xs tw-font-medium" }
const _hoisted_6 = { class: "tw-mb-1 tw-break-all tw-font-semibold tw-leading-none tw-text-deep-orange-600" }
const _hoisted_7 = { class: "tw-break-all tw-leading-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioAvatar = _resolveComponent("StudioAvatar")!
  const _directive_studio_click_outside = _resolveDirective("studio-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StudioAvatar, {
      name: _ctx.email,
      clickable: "",
      onClick: _ctx.toggleOpen
    }, null, 8, ["name", "onClick"]),
    _createVNode(_Transition, { name: "slide" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
                return (_openBlock(), _createElementBlock("button", {
                  id: menuItem.id,
                  key: menuItem.title,
                  "data-testid": menuItem.id,
                  class: "tw-flex tw-w-full tw-items-center tw-gap-2 tw-px-3 tw-py-3 tw-text-sm tw-transition-colors hover:tw-bg-deep-orange-600 hover:tw-text-white focus:tw-bg-deep-orange-50 focus:tw-text-deep-orange-600 focus:tw-ring-0",
                  onClick: 
            () => {
              menuItem.action();
              _ctx.closePopup();
            }
          
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(menuItem.title), 1)
                ], 8, _hoisted_3))
              }), 128)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.email), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.organizationName), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ])), [
    [_directive_studio_click_outside, _ctx.closePopup]
  ])
}